//
// ItemBreadcrumb
//
// A component which returns the label (with unit) a dash (-) and then the name,
// no label create a fallback so it shows only the name (with unit) (no dash)
// If the value is to long we show only the label or name based on the labelView parameter so the user always has the most information.

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'
import { formatItemLabel, formatItemName } from '../../stores/data/utils'
import { maxChars } from '../../utils/text'

export const ItemBreadcrumb = observer(function ItemBreadcrumb({
    item,
    ellipsisAfter,
    ...other
}) {
    const { app, view } = useStore()
    let labelView = view.environment.get('labelView')

    const formattedLabel = formatItemLabel(item, view.language)
    const formattedName = formatItemName(item)

    let breadcrumb
    // if we can show both, we're not changing based on labelView
    breadcrumb = formattedLabel
    if (!breadcrumb) {
        breadcrumb = formattedName
    } else {
        breadcrumb += ' - ' + item.name
    }

    let truncatedBreadcrumb = maxChars(breadcrumb, ellipsisAfter)

    if (!breadcrumb.length) {
        breadcrumb = app.text('[empty]')
        truncatedBreadcrumb = maxChars(breadcrumb, ellipsisAfter)
    } else {
        // if the full breadcrumb gets truncated, show only the label or the name
        // we already know that if both are empty, [empty] is used
        if (truncatedBreadcrumb !== breadcrumb) {
            if (labelView === 'labels') {
                truncatedBreadcrumb = formattedLabel
                if (!truncatedBreadcrumb) {
                    truncatedBreadcrumb = formattedName
                }
            } else {
                truncatedBreadcrumb = formattedName
                if (!truncatedBreadcrumb) {
                    truncatedBreadcrumb = formattedLabel
                }
            }
            truncatedBreadcrumb = maxChars(truncatedBreadcrumb, ellipsisAfter)
        }
    }

    return (
        <span className="cc-ItemBreadcrumb" title={breadcrumb} {...other}>
            {truncatedBreadcrumb}
        </span>
    )
})
